import React from 'react';
import styled from '@benzinga/themetron';

import { convertInlineToReactCSS, isTagVoid, validateReactElementProps } from '@benzinga/frontend-utils';
import { getBlockComponent } from '../components/Block';

export const createHTMLElement = block => {
  try {
    const tagAttributes = {
      ...block.tagAttributes,
    };

    if (block.tagAttributes?.class || block.tagAttributes?.className) {
      tagAttributes['className'] = block.tagAttributes?.class || block.tagAttributes?.className;
      if (tagAttributes['class']) {
        delete tagAttributes['class'];
      }
    } else if (['p', 'div', 'table', 'ul', 'ol', 'h2', 'h1', 'h3', 'h4', 'h5', 'h6'].includes(block.tag)) {
      tagAttributes['className'] = 'block core-block';
      if (block.tag === 'table') {
        tagAttributes['className'] = (
          (tagAttributes['className'] as string).replace('block core-block', '') + ' block core-block'
        ).trim();
      }
    }

    if (block?.tag === 'script') {
      tagAttributes.defer = true;
    }

    if (block?.attrs?.className && block.attrs.className.includes('bz-featured-ad')) {
      tagAttributes['className'] += ' bz-featured-ad';
    }

    if (block.id) {
      tagAttributes['id'] = block.id;
    }

    if (block.tagAttributes?.style !== undefined) {
      tagAttributes['style'] = convertInlineToReactCSS(block.tagAttributes.style);
    }

    if (block?.attrs?.textAlign && block.attrs.textAlign !== '') {
      tagAttributes['className'] += ' ' + block.attrs.textAlign;
    }

    if (block?.attrs?.align && block.attrs.align !== '') {
      tagAttributes['className'] += ' ' + block.attrs.align;
    }

    const elementProps = {
      ...tagAttributes,
    };

    if (block.innerHTML === '\n<p></p>\n' && block.html === '') {
      return <p></p>;
    }

    if (block.html || block.innerHTML || (block.tag !== 'p' && block.tag !== 'div')) {
      let children: string[] = [];

      const isTagVoided = isTagVoid(block?.tag);
      if (!isTagVoided) {
        if (block?.childBlocks?.length) {
          children = block?.childBlocks
            ?.map((item, index) => {
              if (item.nodeType !== 3) {
                return (
                  <React.Fragment key={`core-element-child-block-wrapper-${block.blockName}-${index}`}>
                    {getBlockComponent({ block: item })}
                  </React.Fragment>
                );
              } else if (item.innerHTML || item.html) {
                return item.innerHTML || item.html;
              } else {
                return '';
              }
            })
            .filter(item => !!item);
        } else if (block?.tag === 'table') {
          // HACK: Probably better way to solve this
          if (block?.innerHTML?.slice(0, 8)?.includes('<figure')) {
            return (
              <div
                className="core-block-table-wrapper overflow-x-auto"
                dangerouslySetInnerHTML={{ __html: block.innerHTML }}
              />
            );
          } else {
            elementProps['dangerouslySetInnerHTML'] = {
              __html: `<table class="block core-block">${block.html || block.innerHTML}</table>`,
            };
            elementProps['style'] = {
              overflowX: 'auto',
            };
          }

          return React.createElement('figure', elementProps);
        } else {
          // children.push(unescapeHTML(block.html));
          elementProps['dangerouslySetInnerHTML'] = {
            __html: block.html ?? block.innerHTML,
          };
          return React.createElement(block.tag, elementProps);
        }
      }

      if (block?.tag === 'table') {
        elementProps['dangerouslySetInnerHTML'] = {
          __html: `<table class="block core-block">${block.html || block.innerHTML}</table>`,
        };
        elementProps['style'] = {
          overflowX: 'auto',
        };

        return React.createElement('figure', elementProps);
      } else if (block.tag === 'pre') {
        elementProps['dangerouslySetInnerHTML'] = {
          __html: block.html || block.innerHTML,
        };
        return React.createElement('pre', elementProps);
      } else {
        if (validateReactElementProps(block?.tag, elementProps, isTagVoided ? null : children)) {
          return React.createElement(block?.tag, elementProps, isTagVoided ? null : children);
        } else {
          throw new Error('React Element Props is not valid!');
        }
      }
    }
    if (block?.tag === 'div' && block.innerHTML === '' && Object.keys(block.tagAttributes).length > 1) {
      return React.createElement(block?.tag, elementProps);
    }
    return null;
  } catch (error) {
    console.error('ERROR CREATING HTML ELEMENT:', error);
    return <div dangerouslySetInnerHTML={{ __html: block.innerHTML }} style={{ display: 'inline' }} />;
  }
};

export const CoreElementWrapper = styled.div`
  .right {
    float: right;
    margin-left: 1rem;
    @media screen and (max-width: 648px) {
      max-width: 150px;
    }
  }
  .left {
    float: left;
    margin-right: 1rem;
  }
  > h1,
  > h2 {
    margin-top: 2rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.foregroundInactive};
  }
  > h1 {
    font-size: ${({ theme }) => theme.fontSize['4xl']};
  }
  > h2 {
    font-size: ${({ theme }) => theme.fontSize['3xl']};
  }
  > h3 {
    font-size: ${({ theme }) => theme.fontSize['2xl']};
    margin: 1rem 0px 0.5rem 0px;
  }
  > h4 {
    font-size: ${({ theme }) => theme.fontSize['1xl']};
    margin: 1rem 0px 0.5rem 0px;
  }
  > ul {
    list-style: disc;
    margin-left: 2rem;
    margin-bottom: 2rem;
  }
  > p {
    font-size: 1.1rem;
  }
  a {
    color: #2ca2d1;
  }
  .alignright {
    float: right;
    margin-left: 18px;
  }
  &.image-wrapper {
    margin-bottom: 1rem;
  }
  .wp-block-table {
    overflow-x: auto;

    table {
      margin: 1rem 0;
      width: 100%;
      /* white-space: nowrap; this does not work */

      tbody {
        display: table;
      }

      tr {
        &:first-child {
          border-top: 1px solid #d6d6d6;
        }
        &:nth-child(odd) {
          background: #f9f9f9;
        }
      }
      td {
        /* border-right: 1px solid #d6d6d6; */
        border-bottom: 1px solid #d6d6d6;
        padding: 4px 8px;
        /* &:first-child {
          border-left: 1px solid #d6d6d6;
        } */
      }
    }
  }
  .wp-block-quote {
    padding: 0 1em;
    margin: 0px 0px 2rem;
    line-height: 1.6;
    color: #2d2d2d;
    border-left: 2px solid ${({ theme }) => theme.colorPalette.blue800};
    font-style: italic;
  }
`;

export const CoreImageWrapper = styled.figure`
  display: table;
  .image-caption {
    display: table-caption;
    caption-side: bottom;
    margin-top: 0.5em;
    margin-bottom: 1em;
    padding: 0.4rem;
    border-radius: ${({ theme }) => theme.borderRadius.sm};
    background: #e6e6e6;
    border: 1px solid #d6d6d6;
    width: 100%;
    font-size: ${({ theme }) => theme.fontSize.xl};
    font-weight: 400;

    em {
      color: rgb(40, 61, 89);
    }
  }
`;
